// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBTrwhDuNIn8LhmucNumsrwmx_J2nY2z1g",
  authDomain: "assignment-10-f8cc3.firebaseapp.com",
  projectId: "assignment-10-f8cc3",
  storageBucket: "assignment-10-f8cc3.appspot.com",
  messagingSenderId: "573648624345",
  appId: "1:573648624345:web:51d84e79629914cf317cc8",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export default app;
